var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback, useRef } from "react";
import IntlTelInput from "intl-tel-input/react";
import { Box, InputLabel } from "@mui/material";
import { data } from "../lib/timezone-countrycode-data";
var noop = function () { return undefined; };
var PhoneInput = function (_a) {
    var handlePhoneNumberChange = _a.handlePhoneNumberChange, label = _a.label, fullWidth = _a.fullWidth, initialValue = _a.initialValue, disabled = _a.disabled;
    var handlePhoneNumberChangeRef = useRef(handlePhoneNumberChange);
    handlePhoneNumberChangeRef.current = handlePhoneNumberChange;
    // intl-tel-input re-subscribes and invokes its update callback whenever
    // any callback prop changes, so keep every callback identity stable.
    var onChangeNumber = useCallback(function (number) {
        handlePhoneNumberChangeRef.current(number);
    }, []);
    return (_jsxs(Box, { sx: __assign({ margin: "16px 0" }, (fullWidth && { width: "100%" })), children: [_jsx(InputLabel, { children: label }), _jsx(IntlTelInput, { initOptions: {
                    utilsScript: process.env.PUBLIC_URL + "/intl-tel-input/phoneInput.js",
                    initialCountry: "auto",
                    separateDialCode: true,
                    geoIpLookup: function (success, failure) {
                        var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        var countryCode = data[userTimeZone].toString();
                        if (countryCode) {
                            return success(countryCode);
                        }
                        return failure();
                    },
                }, onChangeNumber: onChangeNumber, onChangeCountry: noop, onChangeValidity: noop, onChangeErrorCode: noop, initialValue: initialValue, disabled: disabled })] }));
};
export default PhoneInput;
